export function isProfessionHubEmpty({ peopleByCity, peopleByProfessionTask }) {
  return !peopleByCity?.length && !peopleByProfessionTask?.length;
}
